import { render } from "./DocumentExecutionRankDialog.vue?vue&type=template&id=c15d2494&ts=true"
import script from "./DocumentExecutionRankDialog.vue?vue&type=script&lang=ts"
export * from "./DocumentExecutionRankDialog.vue?vue&type=script&lang=ts"

import "./DocumentExecutionRankDialog.vue?vue&type=style&index=0&id=c15d2494&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__